module.exports = __webpack_public_path__ + "img/chalk_1.9a9c3bc7.png";